export default __webpack_public_path__ + "static/media/Logo-Say-What.9c50acbe.png";